<template>
  <div class="audit-workbench">
    <div class="review-layout">
      <div class="queue-panel card">
        <div class="card-hd">
          <h3>入驻审核队列</h3>
          <el-tag
            size="mini"
            type="warning"
            effect="plain"
          >{{ queue.length }} 待审</el-tag>
          <el-button
            size="mini"
            type="text"
            style="margin-left:auto"
            @click="$emit('back')"
          >← 切换到管理视图</el-button>
        </div>
        <div class="queue-list">
          <div
            v-for="item in queue"
            :key="item.code"
            class="queue-item"
            :class="{ on: item.code === activeCode }"
            @click="onSelect(item)"
          >
            <div class="qi-name">{{ item.companyName }}</div>
            <div class="qi-meta">
              <el-tag
                :type="stageTagType(item.status)"
                size="mini"
                effect="plain"
              >{{ stageLabel(item.status) }}</el-tag>
              <span class="qi-sla">SLA 剩 {{ item.sla || "--" }}</span>
            </div>
          </div>
          <div v-if="queue.length === 0" class="qi-empty">暂无待审核企业</div>
        </div>
      </div>

      <div v-if="detail" class="detail-col">
        <div class="card">
          <div class="card-hd">
            <h3>托运人信息</h3>
            <span class="card-sub">托运人端 PC 提交 · OCR 已自动审核</span>
            <el-tag
              size="mini"
              type="success"
              effect="plain"
              style="margin-left:auto"
            >证件 OCR 预审通过</el-tag>
          </div>
          <div class="card-bd">
            <dl class="kv-list kv-4">
              <div>
                <dt>企业 ID</dt>
                <dd class="mono">{{ detail.code }}</dd>
              </div>
              <div>
                <dt>客户类型</dt>
                <dd>企业（0）</dd>
              </div>
              <div>
                <dt>公司名称</dt>
                <dd>{{ detail.companyName }}</dd>
              </div>
              <div>
                <dt>统一社会信用代码</dt>
                <dd class="mono">
                  {{ detail.businessLicenseImgNumber || "--" }}
                </dd>
              </div>
              <div>
                <dt>法人代表 / 手机</dt>
                <dd>
                  {{ detail.legalName || "--" }} · {{ detail.phone || "--" }}
                </dd>
              </div>
              <div>
                <dt>行政区划代码</dt>
                <dd class="mono">370705</dd>
              </div>
              <div>
                <dt>注册资金 / 注册日期</dt>
                <dd class="mono">
                  {{ detail.registeredCapital || "--" }} 万 ·
                  {{ detail.establishDate || "--" }}
                </dd>
              </div>
              <div>
                <dt>许可证编号</dt>
                <dd class="mono" style="font-size:11px">
                  {{ detail.roadTransportPermitNo || "--" }}
                </dd>
              </div>
              <div class="kv-span2">
                <dt>企业注册地址</dt>
                <dd>{{ detail.address || "--" }}</dd>
              </div>
              <div class="kv-span2">
                <dt>经营范围</dt>
                <dd>{{ detail.businessScope || "--" }}</dd>
              </div>
              <div>
                <dt>业务负责人</dt>
                <dd>
                  {{ detail.userName || "--" }} · {{ detail.phone || "--" }}
                </dd>
              </div>
              <div>
                <dt>负责人身份证号</dt>
                <dd class="mono">{{ detail.contactsIdnum || "--" }}</dd>
              </div>
              <div>
                <dt>身份证有效期</dt>
                <dd class="mono">{{ detail.contactsIdnumValidity || "--" }}</dd>
              </div>
              <div>
                <dt>主管税务机关</dt>
                <dd>{{ detail.myTaxOrgan || "--" }}</dd>
              </div>
              <div>
                <dt>发票类型</dt>
                <dd>数电增值税专用发票</dd>
              </div>
              <div>
                <dt>发票接收方式</dt>
                <dd>平台内在线下载（无需收票邮箱）</dd>
              </div>
            </dl>
            <p class="kv-tip">
              经营范围含「网络货运」，已要求补充道路运输经营许可证并核验有效期
            </p>
          </div>
        </div>

        <div v-if="ddData" class="card">
          <div class="card-hd">
            <h3>经理尽调材料</h3>
            <span
              class="card-sub"
            >{{ ddData.createdBy || "--" }} ·
              {{ ddData.gmtCreated || "--" }} 提交 · 现场水印照片</span>
          </div>
          <div class="card-bd">
            <dl class="kv-list kv-4">
              <div>
                <dt>所属行业</dt>
                <dd>{{ ddData.industry || "--" }}</dd>
              </div>
              <div>
                <dt>常发货物</dt>
                <dd>{{ ddData.commonCargo || "--" }}</dd>
              </div>
              <div>
                <dt>月均发货</dt>
                <dd class="mono">
                  {{ ddData.monthlyShipments || "--" }} /
                  {{ ddData.monthlyAmount || "--" }} 万
                </dd>
              </div>
              <div>
                <dt>执行费率</dt>
                <dd class="mono">{{ ddData.feeRate || "--" }}%（区间内）</dd>
              </div>
              <div class="kv-span2">
                <dt>常发线路</dt>
                <dd>{{ ddData.commonRoutes || "--" }}</dd>
              </div>
              <div class="kv-span2">
                <dt>尽调结论</dt>
                <dd>{{ ddData.ddConclusion || "--" }}</dd>
              </div>
            </dl>
          </div>
        </div>

        <div class="card">
          <div class="card-hd">
            <h3>承运主体信息</h3>
            <span class="card-sub">审核通过时确认，直接决定合同主体与费率</span>
          </div>
          <div class="card-bd">
            <div class="form-grid-3">
              <div class="fld">
                <label
                  class="fld-lbl"
                ><span class="req">*</span>承运主体（签约主体）</label>
                <el-select
                  v-model="auditForm.branchCode"
                  size="small"
                  style="width:100%"
                  :disabled="trackRole === 'risk'"
                >
                  <el-option
                    v-for="b in branchList"
                    :key="b.code"
                    :label="b.groupName"
                    :value="b.code"
                  />
                </el-select>
              </div>
              <div class="fld">
                <label
                  class="fld-lbl"
                ><span class="req">*</span>服务费率（%）</label>
                <el-input
                  v-model="auditForm.taxPoint"
                  size="small"
                  placeholder="如：6.5"
                  :disabled="trackRole === 'risk'"
                />
                <p class="fld-hint">
                  尽调建议 {{ ddData ? ddData.feeRate : "--" }}% · 指导区间
                  5%-8%
                </p>
              </div>
              <div class="fld">
                <label
                  class="fld-lbl"
                ><span class="req">*</span>平台服务经理</label>
                <el-select
                  v-model="auditForm.salesmanCode"
                  size="small"
                  style="width:100%"
                  :disabled="trackRole === 'risk'"
                >
                  <el-option
                    v-for="s in salesmanOptions"
                    :key="s.code"
                    :label="s.name"
                    :value="s.code"
                  />
                </el-select>
              </div>
              <div class="fld">
                <label class="fld-lbl">是否月结客户</label>
                <el-select
                  v-model="auditForm.isMonthly"
                  size="small"
                  style="width:100%"
                  :disabled="trackRole === 'risk'"
                >
                  <el-option label="是 · 月结 30 天" value="1" /><el-option
                    label="否 · 现结"
                    value="0"
                  />
                </el-select>
              </div>
              <div class="fld">
                <label class="fld-lbl">是否需要发货保证金</label>
                <el-select
                  v-model="auditForm.needDeposit"
                  size="small"
                  style="width:100%"
                  :disabled="trackRole === 'risk'"
                >
                  <el-option label="否" value="0" /><el-option
                    label="是"
                    value="1"
                  />
                </el-select>
              </div>
              <div class="fld">
                <label class="fld-lbl">建议授信额度（元）</label>
                <el-input
                  v-model="auditForm.creditAmount"
                  size="small"
                  placeholder="如：3000000"
                  :disabled="trackRole === 'risk'"
                />
                <p class="fld-hint">风控建议值，可按评分调整</p>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-hd">
            <h3>结算账户信息</h3>
          </div>
          <div class="card-bd">
            <dl class="kv-list kv-4">
              <div>
                <dt>开户行</dt>
                <dd>{{ detail.bankName || "--" }}</dd>
              </div>
              <div>
                <dt>开户支行</dt>
                <dd>{{ detail.bankBranch || "--" }}</dd>
              </div>
              <div>
                <dt>账号</dt>
                <dd class="mono">{{ detail.bankAccount || "--" }}</dd>
              </div>
              <div>
                <dt>开户行行号</dt>
                <dd class="mono">{{ detail.bankAssociationNumber || "--" }}</dd>
              </div>
            </dl>
          </div>
        </div>

        <div class="dual-tracks">
          <CsTrack
            ref="csTrack"
            :apply-code="activeCode"
            :readonly="trackRole !== 'cs'"
            :dd-data="ddData"
          />
          <RiskTrack
            ref="riskTrack"
            :apply-code="activeCode"
            :readonly="trackRole !== 'risk'"
            :dd-data="ddData"
          />
        </div>

        <div class="card">
          <div class="card-bd audit-ft">
            <div class="fld">
              <label
                class="fld-lbl"
              >审核意见（驳回时必填，将按角色语言分别通知经理与托运人）</label>
              <el-input
                v-model="auditRemark"
                type="textarea"
                :rows="2"
                placeholder="如：历史发货佐证不足，请补充近 3 个月运单/合同/结算流水至少 3 份"
                size="small"
              />
            </div>
            <div class="audit-btns">
              <el-button
                size="small"
                type="danger"
                @click="onAudit('RETURN')"
              >审核驳回</el-button>
              <el-button
                size="small"
                @click="onAskMore"
              >要求补充材料</el-button>
              <el-button
                size="small"
                type="primary"
                :loading="auditing"
                @click="onAudit('PASS')"
              >本轨审核通过</el-button>
            </div>
            <p class="audit-note">
              双轨全部通过后企业状态自动流转「待签约」，签约邀请短信发送托运人联系人
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CsTrack from "./CsTrack.vue";
import RiskTrack from "./RiskTrack.vue";
import {
  getApplyList,
  getApplyDetail,
  getDueDiligence,
  csAudit,
  riskAudit
} from "@/api/shipmentApply";
import { salesmanList } from "@/api/shipment";

const STAGE_MAP = {
  CS: { label: "客服轨待审", type: "info" },
  RISK: { label: "风控轨待审", type: "" },
  FIX: { label: "驳回待复核", type: "danger" }
};

const DEFAULT_AUDIT_FORM = {
  branchCode: "",
  taxPoint: "6.5",
  salesmanCode: "",
  isMonthly: "1",
  needDeposit: "0",
  creditAmount: "3000000"
};

function hasValue(value) {
  return value !== undefined && value !== null && value !== "";
}

function formValue(value, fallback) {
  return hasValue(value) ? String(value) : fallback;
}

function buildAuditForm(detail, ddData) {
  const apply = detail || {};
  const dueDiligence = ddData || {};
  const suggestedTaxPoint = formValue(
    dueDiligence.feeRate,
    DEFAULT_AUDIT_FORM.taxPoint
  );
  return {
    branchCode: formValue(apply.branchCode, DEFAULT_AUDIT_FORM.branchCode),
    taxPoint: formValue(apply.carrierTaxPoint, suggestedTaxPoint),
    salesmanCode: formValue(apply.salesmanCode, DEFAULT_AUDIT_FORM.salesmanCode),
    isMonthly: formValue(apply.carrierIsMonthly, DEFAULT_AUDIT_FORM.isMonthly),
    needDeposit: formValue(
      apply.carrierNeedDeposit,
      DEFAULT_AUDIT_FORM.needDeposit
    ),
    creditAmount: formValue(
      apply.carrierCreditAmount,
      DEFAULT_AUDIT_FORM.creditAmount
    )
  };
}

export default {
  name: "AuditWorkbench",
  components: { CsTrack, RiskTrack },
  props: {
    activeCode: { type: String, default: "" },
    trackRole: { type: String, default: "cs" }
  },
  data() {
    return {
      queue: [],
      detail: null,
      ddData: null,
      auditForm: { ...DEFAULT_AUDIT_FORM },
      auditRemark: "",
      auditing: false,
      branchList: this.$store.state.components.branchList || [],
      salesmanOptions: []
    };
  },
  watch: {
    // 签约主体变化时重新按主体拉取平台经理（市场角色全量、渠道角色按主体）
    "auditForm.branchCode"() {
      this.loadSalesmanList();
    }
  },
  created() {
    this.fetchQueue();
    this.loadSalesmanList();
  },
  methods: {
    async fetchQueue() {
      try {
        const statusFilter = this.trackRole === "cs" ? "CS" : "RISK";
        const res = await getApplyList({
          pageNum: 1,
          pageSize: 100,
          statusIn: statusFilter
        });
        this.queue = (res.data && res.data.records) || [];
        if (!this.activeCode && this.queue.length > 0)
          this.onSelect(this.queue[0]);
      } catch (e) {
        this.$message.error((e && e.message) || "加载审核队列失败");
      }
    },
    async loadSalesmanList() {
      try {
        const res = await salesmanList({ branchCode: this.auditForm.branchCode });
        this.salesmanOptions = res.data || [];
      } catch (e) {
        /* ignore */
      }
    },
    async onSelect(item) {
      this.activeCode = item.code;
      this.auditForm = { ...DEFAULT_AUDIT_FORM };
      try {
        const res = await getApplyDetail(item.code);
        this.detail = res.data || item;
      } catch (e) {
        this.detail = item;
      }
      try {
        const ddRes = await getDueDiligence(item.code);
        this.ddData = ddRes.data || null;
      } catch (e) {
        this.ddData = null;
      }
      this.auditForm = buildAuditForm(this.detail, this.ddData);
    },
    stageLabel(s) {
      return (STAGE_MAP[s] || {}).label || s;
    },
    stageTagType(s) {
      return (STAGE_MAP[s] || {}).type || "";
    },
    async onAudit(action) {
      if (action === "RETURN" && !this.auditRemark) {
        this.$message.warning("驳回时必须填写审核意见");
        return;
      }
      this.auditing = true;
      try {
        const csItems = (this.$refs.csTrack && this.$refs.csTrack.items) || [];
        const payload = {
          applyCode: this.activeCode,
          action,
          remark: this.auditRemark,
          branchCode: this.auditForm.branchCode || "",
          salesmanCode: this.auditForm.salesmanCode || "",
          carrierTaxPoint: this.auditForm.taxPoint || "",
          carrierIsMonthly: this.auditForm.isMonthly || "",
          carrierNeedDeposit: this.auditForm.needDeposit || "",
          carrierCreditAmount: this.auditForm.creditAmount || "",
          verifyCompany: 1,
          certConsistency: csItems.find(i => i.key === "cert")
            ? csItems.find(i => i.key === "cert").pass
              ? "pass"
              : "fail"
            : null,
          faceVerify: csItems.find(i => i.key === "face")
            ? csItems.find(i => i.key === "face").pass
              ? "pass"
              : "fail"
            : null,
          demandMatch: csItems.find(i => i.key === "match")
            ? csItems.find(i => i.key === "match").pass
              ? "pass"
              : "fail"
            : null,
          ddSpotCheck: csItems.find(i => i.key === "dd_spot")
            ? csItems.find(i => i.key === "dd_spot").pass
              ? "pass"
              : "fail"
            : null
        };
        if (this.trackRole === "cs") {
          await csAudit(payload);
        } else {
          await riskAudit(payload);
        }
        this.$message.success(action === "PASS" ? "审核通过" : "已驳回");
        this.auditRemark = "";
        this.fetchQueue();
      } catch (e) {
        this.$message.error((e && e.message) || "操作失败");
      } finally {
        this.auditing = false;
      }
    },
    onAskMore() {
      this.$message.info("已通知企业补充材料");
    }
  }
};
</script>

<style lang="scss" scoped>
.audit-workbench {
  .review-layout {
    display: grid;
    grid-template-columns: 280px 1fr;
    gap: 16px;
    align-items: start;
    @media (max-width: 1100px) {
      grid-template-columns: 1fr;
    }
  }
  .detail-col {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .card {
    background: var(--surface);
    border: 1px solid var(--line);
    border-radius: var(--r-lg);
    box-shadow: var(--sh);
    overflow: hidden;
  }
  .card-hd {
    padding: 14px 16px;
    border-bottom: 1px solid var(--line2);
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    h3 {
      font-size: 13px;
      font-weight: 700;
      margin: 0;
      display: flex;
      align-items: center;
      gap: 8px;
      &::before {
        content: "";
        width: 3px;
        height: 12px;
        border-radius: 2px;
        background: var(--grad);
      }
    }
    .card-sub {
      font-size: 11px;
      color: var(--ink3);
    }
  }
  .card-bd {
    padding: 14px 16px;
  }

  .queue-list {
    padding: 0;
  }
  .queue-item {
    padding: 12px 14px;
    border-bottom: 1px solid var(--line2);
    cursor: pointer;
    transition: 0.12s;
    &:hover {
      background: rgba(66, 109, 240, 0.03);
    }
    &.on {
      background: rgba(66, 109, 240, 0.06);
      border-left: 3px solid var(--b1);
      padding-left: 11px;
    }
    .qi-name {
      font-size: 13px;
      font-weight: 600;
      color: var(--ink);
      margin-bottom: 4px;
    }
    .qi-meta {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .qi-sla {
      font-size: 11px;
      color: var(--ink4);
    }
  }
  .qi-empty {
    padding: 32px 0;
    text-align: center;
    font-size: 12px;
    color: var(--ink4);
  }

  .kv-list {
    margin: 0;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px 16px;
    @media (max-width: 900px) {
      grid-template-columns: repeat(2, 1fr);
    }
    dt {
      font-size: 11px;
      color: var(--ink4);
      margin-bottom: 2px;
    }
    dd {
      font-size: 12px;
      color: var(--ink);
      line-height: 1.5;
      word-break: break-all;
      margin: 0;
    }
    dd.mono {
      font-size: 11px;
      color: var(--ink2);
    }
  }
  .kv-span2 {
    grid-column: span 2;
  }
  .kv-tip {
    font-size: 11px;
    color: var(--ink4);
    margin-top: 10px;
  }

  .form-grid-3 {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px 16px;
    @media (max-width: 900px) {
      grid-template-columns: 1fr 1fr;
    }
  }
  .fld {
    margin-bottom: 0;
  }
  .fld-lbl {
    font-size: 11px;
    font-weight: 600;
    color: var(--ink2);
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    gap: 4px;
    .req {
      color: var(--err);
    }
  }
  .fld-hint {
    font-size: 10px;
    color: var(--ink4);
    margin-top: 4px;
  }

  .dual-tracks {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    @media (max-width: 1100px) {
      grid-template-columns: 1fr;
    }
  }

  .audit-ft {
    padding: 16px;
  }
  .audit-btns {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    margin-top: 14px;
    flex-wrap: wrap;
  }
  .audit-note {
    font-size: 11px;
    color: var(--ink4);
    text-align: right;
    margin: 8px 0 0;
  }
}
</style>
